import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Card from './styled-components/Card'
import Form, { FormInputs } from './styled-components/Form'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import ButtonRow from './styled-components/ButtonRow'
import { ButtonPrimary, ButtonSecondaryLink } from './styled-components/Button'
import MaterialTextField from './styled-components/MaterialTextField'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import sendPasswordResetEmail from '../sendPasswordResetEmail'
import emailExistsInFirebase from '../emailExistsInFirebase'
import emailExistsInCognito from '../emailExistsInCognito'
import sendCognitoPasswordResetEmail from '../sendCognitoPasswordResetEmail'
import errorMessages from '../errorMessages'
import { AnovaLogoSmall } from './AnovaLogo'
import ToastMessage from './ToastMessage'
import { analyticsPage, analyticsTrack } from '../analytics'

class PasswordResetEmailForm extends Component {
  state = {
    redirectToPasswordResetEmailSent: false,
    shouldShowErrorToast: false
  }

  checkEmailAndSendPasswordResetEmail = async (event) => {
    event.preventDefault()

    this.dismissToastMessage()

    try {
      const isExistingFirebaseUser = await emailExistsInFirebase(this.props.email)

      if (isExistingFirebaseUser) {
        await sendPasswordResetEmail(this.props.email)
      } else {
        const isExistingCognitoUser = await emailExistsInCognito(this.props.email)

        if (!isExistingCognitoUser) {
          throw new Error('user is not found in firebase or cognito')
        }

        await sendCognitoPasswordResetEmail(this.props.email)
      }

      this.setState({ redirectToPasswordResetEmailSent: true })
    } catch (error) {
      if (error.code === 'auth/invalid-email') {
        this.props.setInvalidEmail(true)
      } else {
        this.setState({ shouldShowErrorToast: true })
      }

      analyticsTrack('ALI Errored', {
        'message': error.message
      })
    }
  }

  dismissToastMessage = () => {
    this.setState({ shouldShowErrorToast: false })
  }

  componentDidMount () {
    analyticsPage('ALI Password Reset - Email Form')
  }

  render () {
    return (
      <Card>
        {this.state.redirectToPasswordResetEmailSent ? <Redirect to="/password-reset-email-sent" /> : null}

        {
          this.state.shouldShowErrorToast
            ? <ToastMessage
              messageText={'Something went wrong. Please try again.'}
              dismissToastMessage={this.dismissToastMessage} />
            : null
        }

        <div>
          <AnovaLogoSmall />
        </div>

        <Form onSubmit={this.checkEmailAndSendPasswordResetEmail} noValidate>
          <HeaderText>Reset your password</HeaderText>
          <HeaderTextSmall>Enter your email and receive<br />instructions to reset your password</HeaderTextSmall>
          <FormInputs>
            <MaterialTextField
              showErrorText={this.props.invalidEmail}
              errorMessage={errorMessages.invalidEmail}
              type="email"
              label="Email"
              autoFocus={true}
              onChange={event => this.props.handleEmailChangeAndClearEmailErrors(event.target.value)}
              value={this.props.email}
              name="emailInput" />
            <ButtonRow>
              <ButtonSecondaryLink
                text="BACK"
                href="/" />
              <ButtonPrimary
                type="submit"
                onClick={this.checkEmailAndSendPasswordResetEmail}
                disabled={!this.props.email}
                data-password-reset-form-send>
                SEND
              </ButtonPrimary>
            </ButtonRow>
          </FormInputs>
        </Form>

        <TermsOfServiceAndPrivacyPolicy />
      </Card >
    )
  }
}

export default PasswordResetEmailForm
